import { VendorUserType } from "auth/VendorAuth/vendorUserSlice";
import { useAppSelector } from "hooks/redux";
import { filter, forEach, groupBy } from "lodash";
import { selectRfi } from "store/rfiSlice";
import { ElementVendorQuestion } from "../../types/RfiTypes";
import QandA from "./QandA";

interface IQandAProps {
  section?: string;
  user?: VendorUserType;
  isQAOpen: boolean;
}

const QandASection = (props: IQandAProps) => {
  // Hooks
  const rfi = useAppSelector(selectRfi);

  // Functions
  const RenderQuestions = (section: string) => {
    let sectionQuestions = filter(
      rfi.vendorQuestions,
      (question: ElementVendorQuestion) => {
        return !section ? !question.section : question.section === section;
      }
    );

    let groupedQuestions = groupBy(
      sectionQuestions,
      (question: ElementVendorQuestion) => {
        return question.questionNumber ?? 0;
      }
    );
    const questions: any = [];
    groupedQuestions &&
      forEach(groupedQuestions, (value, key) => {
        const question = value.map(
          (question: ElementVendorQuestion, i: number) => {
            return (
              <div key={i}>
                {i === 0 && (
                  <>
                    <strong>
                      {question.questionNumber
                        ? `${question.questionNumber}.`
                        : ""}{" "}
                      {question.fieldLabel}
                    </strong>{" "}
                    <br />
                  </>
                )}
                <QandA
                  key={question.rfxVendorQuestionId}
                  question={question}
                  user={props.user}
                  isQAOpen={props.isQAOpen}
                ></QandA>
              </div>
            );
          }
        );
        question && questions.push(question);
      });
    return questions;
  };

  // Render
  return <>{RenderQuestions(props.section ?? "")}</>;
};

export default QandASection;
